import { render, staticRenderFns } from "./viewPermissaoAcesso.vue?vue&type=template&id=73557404&"
import script from "./viewPermissaoAcesso.vue?vue&type=script&lang=js&"
export * from "./viewPermissaoAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports